export default function QuestionNewWebsite({ register, errors }) {
  const fieldName = "questionnewwebsite";

  return (
    <div>
      <label className="wdc-field-label" htmlFor={fieldName}>
        Is this a new website?
      </label>
      <select
        id={fieldName}
        className="wdc-field"
        {...register(fieldName, { required: true })}
      >
        <option value="">Select an option</option>
        <option value="new">New website on a new domain name</option>
        <option value="replace">Replacing existing/outdated website</option>
      </select>
      {errors[fieldName] && (
        <span className="wdc-error">This field is required</span>
      )}
    </div>
  );
}
